<template>
  
     <!-- Raiz da aplicação Vuetify -->
    <v-app> 

        <!-- Área principal da aplicação -->
        <v-main> 

            <!-- Barra preta -->
            <v-toolbar
                color="black"
                dense
                flat
                :style="{
                    'border-top-left-radius': '12px',
                    'border-top-right-radius': '8px',
                    'position': 'fixed',
                    'top': '64px',
                    'left': modoBarraLateral ? '70px' : '260px',
                    'width': modoBarraLateral ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
                    'z-index': '999',
                    'transition': 'left 0.3s ease, width 0.3s ease'
                }"
            >                      
                <v-toolbar-title class="white--text">Liberação de Equipamentos</v-toolbar-title> 
                <v-spacer />

            </v-toolbar>

            <v-container fluid>

                <!-- Card que agrupa elementos do formulário  -->
                <v-card class="pa-4" style="width: 100%; top: 60px;">

                    <!-- Formulário de liberação de equipamentos -->
                    <v-form ref="formLiberaEquipamentos" v-model="validaLiberacaoEquipamentos">

                        <v-row>
                          
                            <!-- COLUNA ESQUERDA: FORMULÁRIO -->
                            <v-col cols="12" md="6">

                                <v-card class="pa-4" elevation="12">

                                    <!-- EMPRESA -->
                                    <v-select
                                        v-model="empresaSelecionada"
                                        :items="empresas"
                                        label="Empresa"
                                        item-title="nomeFantasia"
                                        item-value="idEmpresa"
                                        density="comfortable"
                                        @update:model-value="carregaDadosKit"
                                        @click:clear="limpaDadosAposLiberacao"
                                        :clearable="true"
                                        :rules="[rules.required]"
                                    />

                                    <!-- MOTORISTA -->
                                    <v-select
                                        v-model="motoristaSelecionado"
                                        :items="motoristas"
                                        label="Motorista"
                                        item-title="nomeMotorista"
                                        item-value="idMotorista"
                                        density="comfortable"
                                        class="mt-4"
                                        :rules="[rules.required]"
                                    />

                                    <!-- REPÓRTER -->
                                    <v-select
                                        v-model="reporterSelecionado"
                                        :items="reporteres"
                                        label="Repórter"
                                        item-title="nomeReporter"
                                        item-value="idReporter"
                                        density="comfortable"
                                        class="mt-4"
                                        :rules="[rules.required]"
                                    />

                                    <!-- CINEGRAFISTA -->
                                    <v-select
                                        v-model="cinegrafistaSelecionado"
                                        :items="cinegrafistas"
                                        label="Cinegrafista"
                                        item-title="nomeCinegrafista"
                                        item-value="idCinegrafista"
                                        density="comfortable"
                                        class="mt-4"
                                        :rules="[rules.required]"
                                    />

                                    <!-- DESCRIÇÃO DA PAUTA -->
                                    <v-textarea
                                        v-model="descricaoPauta"
                                        label="Descrição da pauta"
                                        rows="3"
                                        auto-grow
                                        class="mt-4"
                                        :rules="[rules.required]"
                                    />

                                    <!-- EQUIPAMENTOS (AUTOCOMPLETE) -->
                                    <v-autocomplete
                                        v-if="mostrarAutocomplete"
                                        ref="focoEquipamento"
                                        v-model="equipamentoSelecionado"
                                        :items="equipamentos"
                                        label="Equipamentos"
                                        item-title="nomeEquipamento"
                                        item-value="idEquipamento"
                                        density="comfortable"
                                        class="mt-4"
                                        :rules="[rules.required]"
                                        @update:modelValue="validaLiberaEquipamentos"
                                        @keydown.enter.prevent="processarEnter"
                                    />

                                    <!-- SELEÇÃO DE EQUIPAMENTOS LIBERADOS -->
                                    <v-select
                                        v-if="equipamentosLiberados && equipamentosLiberados.length > 0"
                                        v-model="equipamentosLiberadosSelecao"
                                        :items="equipamentosLiberados"
                                        item-title="title"
                                        item-value="value"
                                        multiple
                                        chips
                                        closable-chips
                                        :clearable="true"
                                        bg-color="white"
                                        style="margin-top: 25px; width: 100%;"
                                        label="Equipamentos Kit"
                                        @update:modelValue="aoAtualizarSelecao"
                                    >
                                        <template v-slot:chip="{ props, item }">
                                            <v-chip
                                                v-bind="props"
                                                color="primary"
                                                class="ma-1"
                                                closable
                                                @click:close="removeEquipamentosKit(item)"
                                            >
                                                {{ item.title }}
                                            </v-chip>

                                        </template>

                                    </v-select>

                                    <v-btn
                                        v-if="equipamentosLiberadosSelecao.length > 0"
                                        color="green-darken-2"
                                        class="mt-4"
                                        block
                                        size="large"
                                        @click="liberarKit"
                                        style="
                                            background: linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%);
                                            box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);
                                            font-weight: bold;
                                        "
                                    >
                                        <v-icon start>mdi-check-circle</v-icon>
                                        Liberar Kit
                                    </v-btn>

                                </v-card>

                            </v-col>

                            <!-- COLUNA DIREITA: FORMULÁRIO -->
                            <v-col cols="12" md="6">

                                <v-card class="pa-4" elevation="12">
                                
                                    <v-text-field
                                        ref="inputPesquisaEquipamento"
                                        v-model="pesquisaKitEquipamento"
                                        label="Devolução Equipamentos"
                                        placeholder="Entre Com o Código do Equipamento, Pressione Enter..."
                                        prepend-inner-icon="mdi-magnify"
                                        variant="outlined"
                                        :clearable="true"
                                        @keyup.enter="buscaIdKitPorIdEquipamento"                                        
                                    >
                                    
                                        <template v-slot:append-inner>
                                            <v-icon 
                                                @click="buscaIdKitPorIdEquipamento"
                                                title="Buscar kit por equipamento"
                                                style="cursor: pointer;"
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </template>

                                    </v-text-field>

                                    <!-- TABELA DE KITS LIBERADOS -->
                                    <v-data-table-server
                                        v-model:expanded="tabelaExpandida"
                                        :headers="cabecalhoTabelaKit"
                                        :items="itensTabelaKits"
                                        :items-length="totalItems"
                                        :loading="carregandoTabelaKits"
                                        item-value="idKit"
                                        @update:options="carregaListaKits"
                                        show-expand
                                        @update:expanded="expandeRecolheTabela"
                                        :single-expand="true"
                                        hide-default-footer
                                    >
                                        <template v-slot:item="{ item, internalItem, toggleExpand, isExpanded }">

                                            <tr
                                                style="cursor: pointer"
                                                :class="{ 
                                                    'bg-grey-lighten-3': isExpanded(internalItem) 
                                                }">
                                                
                                                <!-- Coluna de ícones -->
                                                <td>
                                                    <div class="d-flex ga-2">
                                                        <v-icon 
                                                            @click="imprimeReciboLiberacao(item.idKit)"
                                                            color="primary"
                                                            style="cursor: pointer;"
                                                            title="Imprimir Recibo"
                                                        >
                                                            mdi-printer
                                                        </v-icon>
                                                    </div>
                                                </td>
                                                
                                                <!-- ID Kit -->
                                                <td @click="toggleExpand(internalItem)">
                                                    <a href="#" @click.stop="toggleExpand(internalItem)">{{ item.idKit }}                                                    </a>
                                                </td>
                                                
                                                <!-- Responsável -->
                                                <td @click="toggleExpand(internalItem)">{{ item.nomeResponsavel }}</td>
                                                
                                                <!-- Data Liberação -->
                                                <td @click="toggleExpand(internalItem)">{{ proxy.$formataDataBrasil(item.dataLiberacao) }}</td>

                                                <!-- Botão expandir -->
                                                <td>
                                                    <v-btn
                                                        :icon="isExpanded(internalItem) ? '$collapse' : '$expand'"
                                                        size="small"
                                                        variant="text"
                                                        @click="toggleExpand(internalItem)"
                                                    />
                                                </td>

                                            </tr>

                                        </template>

                                        <!-- Template para linha expandida -->
                                        <template v-slot:expanded-row="{ columns, item }">

                                            <tr>
                                            
                                                <td :colspan="columns.length">
                                            
                                                    <v-card flat variant="tonal">
                                            
                                                        <v-data-table
                                                            ref="tabelaExpandidaRef"
                                                            :headers="cabecalhoTabelaExpandida"
                                                            :items="item.expandedData || []"
                                                            :loading="item.carregandoTabelaExtendida"
                                                            hide-default-footer
                                                            density="compact"
                                                            class="text-caption expanded-data-table"
                                                        >
                                                            <!-- Template para quando não há dados -->
                                                            <template v-slot:no-data>
                                                                <div class="text-center pa-4 text-grey">
                                                                    Nenhum equipamento encontrado para este kit
                                                                </div>
                                                            </template>

                                                            <!-- Template para loading -->
                                                            <template v-slot:loading>

                                                                <div class="text-center pa-4">
                                                                
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="primary"
                                                                        size="12"
                                                                    />
                                                                    
                                                                    <span class="ml-2">Carregando equipamentos...</span>
                                                                
                                                                </div>

                                                            </template>

                                                            <!-- Template para ações em cada equipamento -->
                                                            <template v-slot:item.actions="{ item: equipamento }">

                                                                <div class="d-flex ga-2 justify-center">

                                                                    <!-- Ícone 1: Devolução -->
                                                                    <v-tooltip text="Devolver equipamento" location="top">

                                                                        <template v-slot:activator="{ props }">
                                                                            <v-btn
                                                                                v-bind="props"
                                                                                icon
                                                                                variant="text"
                                                                                color="success"
                                                                                size="x-small"
                                                                                @click="iconeDevolverEquipamento(equipamento, item)"
                                                                            >
                                                                                <v-icon>mdi-arrow-left-circle</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                    
                                                                    </v-tooltip>
                                                                    
                                                                    <!-- Ícone 2: Avaria -->
                                                                    <v-tooltip text="Registrar Avaria" location="top">

                                                                        <template v-slot:activator="{ props }">
                                                                            <v-btn
                                                                                v-bind="props"
                                                                                icon
                                                                                variant="text"
                                                                                color="error"
                                                                                size="x-small"
                                                                                @click="iconeDevolverEquipamentoAvaria(equipamento, item)"
                                                                            >
                                                                                <v-icon>mdi-alert-circle</v-icon>
                                                                            </v-btn>
                                                                        </template>

                                                                    </v-tooltip>
                                                                    
                                                                    <!-- Ícone 3: Movimentar outro kit -->
                                                                    <v-tooltip text="Movimentar Para Outro Kit" location="top">

                                                                        <template v-slot:activator="{ props }">
                                                                            <v-btn
                                                                                v-bind="props"
                                                                                icon
                                                                                variant="text"
                                                                                color="primary"
                                                                                size="x-small"
                                                                                @click="movimentarOutroKit(equipamento, item)"
                                                                            >
                                                                                <v-icon>mdi-truck-fast</v-icon>
                                                                            </v-btn>
                                                                        </template>

                                                                    </v-tooltip>

                                                                </div>

                                                            </template>
                                                        
                                                        </v-data-table>
                                                    
                                                    </v-card>
                                                
                                                </td>
                                            
                                            </tr>

                                        </template>
                                    
                                    </v-data-table-server>
                                
                                </v-card>

                            </v-col>
                        </v-row>
                    
                    </v-form>

                </v-card>

            </v-container>

            <!-- Modal de Movimentação -->
            <ModalRegistraAvariaEquipamento
                ref="modalRegistroAvariaEquipamentoref"
                @registro-avaria-concluido="onRegistroAvariaConcluido"
            />
        </v-main>
    
    </v-app>


</template>

<script setup>

    /* DEPENDENCIAS E VARIAVEIS COMUNS */
    import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
  
    // Importa axios para chamadas API
    import axios from 'axios'

    // Importa o emitter para comunicação entre componentes
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa o event bus
    import { emitter } from '../utils/eventBus'

    // Importa o componente do formulário de erros
    import { useErroStore } from '@/stores/erroStore'

    // Importa o componente do Snackbar
    import { useSnackbarStore } from '@/stores/snackbar'

    // Retorna um objeto com informações internas sobre o componente que está sendo executado no momento    
    import { getCurrentInstance } from 'vue'

    // Importa o componente do formulário de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa useRouter para acessar parâmetros de rota
    import { useRouter } from 'vue-router'

    // Importa o serviço de impressão
    import { impressaoService } from '@/services/impressaoService'

    import ModalRegistraAvariaEquipamento from '@/components/ModalRegistraAvariaEquipamento.vue'

    // Carrega o endereço das ap
    const API_BASE_URL = import.meta.env.VITE_API_URL;
    
    // Importa a store de erros
    const erroStore = useErroStore()

    // Importa a store do snackbar
    const snackbar = useSnackbarStore()

    // Importa a store de chamados
    const loginStore = useLoginStore()

    // Acessa o ID da empresa via query param
    const router = useRouter();

    // Permite acessar rotinas globais
    const { proxy } = getCurrentInstance()

    // Estado local para o modo da barra lateral
    const modoBarraLateral = ref(false)

    // Cria variáveis reativas para armazenar os dados das empresas, motoristas, repórteres e equipamentos
    const empresas = ref([])
    const motoristas = ref([])
    const reporteres = ref([])
    const cinegrafistas = ref([])
    const equipamentos = ref([])
    const equipamentosLiberados = ref([])

    /* MODELS */
    const empresaSelecionada = ref(null)
    const motoristaSelecionado = ref(null)
    const reporterSelecionado = ref(null)
    const cinegrafistaSelecionado = ref(null)
    const descricaoPauta = ref(null)
    const equipamentoSelecionado = ref(null)
    const equipamentosLiberadosSelecao = ref([])
    const pesquisaKitEquipamento = ref('')

    const mostrarAutocomplete = ref(true)
    const focoEquipamento = ref(null)
    
    // Referência para o input de pesquisa
    const inputPesquisaEquipamento = ref(null)

    // Ref para o formulário de liberação de equipamentos
    const formLiberaEquipamentos = ref(null)

    // Variável para controlar a validação do formulário de liberação de equipamentos
    const validaLiberacaoEquipamentos = ref(false)

    // Variável referencia do modal de registro de avarias de equipamentos
    const modalRegistroAvariaEquipamentoref = ref(null)

    const itensTabelaKits = ref([])
    const carregandoTabelaKits = ref(true)
    const totalItems = ref(0)
    const tabelaExpandida = ref([])    
    
    // Declare a ref da tabela extendida
    const tabelaExpandidaRef = ref(null)

    // cabecalhoTabelaKit - Atualizado para remover a coluna Funções que agora é tratada via template
    const cabecalhoTabelaKit = [
        { title: 'Funções', key: 'funcoes', sortable: false, align: 'start', width: '20' },
        { title: 'Kit', key: 'idKit', sortable: true, align: 'start' },
        { title: 'Responsável', key: 'nomeResponsavel', sortable: true },
        { title: 'Liberado Em', key: 'dataLiberacao', sortable: true },
        { title: '', key: 'data-table-expand', sortable: false, width: '48px' }
    ]

    const cabecalhoTabelaExpandida = [
        { title: 'Funções', key: 'actions', sortable: false, align: 'center', width: '120' },
        { title: 'Código', key: 'idEquipamentoKit' },
        { title: 'Equipamento', key: 'equipamento' },
        { title: 'Descrição', key: 'descricao' },
    ]

    // Regras de validação
    const rules = {
        required: v => !!v || 'Campo obrigatório'
    }
    
    // Função para buscar os equipamentos de um kit a partir do código de um equipamento
    const buscaIdKitPorIdEquipamento = async () => {
        
        // Verifica se o campo de pesquisa de equipamento não está vazio antes de fazer a busca
        if (pesquisaKitEquipamento.value && pesquisaKitEquipamento.value.trim() !== '') {          
        
            try {
                
                // Limpa a tabela e expande para evitar inconsistências visuais durante o carregamento
                tabelaExpandida.value = []

                // Busca o código do equipamento digitado, convertendo para maiúsculas e 
                // removendo espaços extras para garantir consistência na busca
                const equipamento = pesquisaKitEquipamento.value.trim().toUpperCase()

                // Faz a chamada à API para buscar o kit pelo código do equipamento
                const { data } = await axios.get(
                    `${API_BASE_URL}/operacao/buscaIdKitPorEquipamento/${loginStore.idEmpresa}/${equipamento}`, {
                        headers: {
                            Authorization: `Bearer ${loginStore.token}`
                        }
                    }
                )
                
                // Verifica se a resposta da API contém dados e se o array de dados não está vazio
                if (data.data.length === 0) {                    
                    snackbar.trigger('Equipamento: ' + equipamento + ' Não Se Encontra Em Nenhum Kit.', 'error');
                } else {

                    // Busca o idKit no retorno da api
                    const idKit = data.data.idKit

                    // Expande a tabela de equipamentos do kit apontado por data.data.idKit
                    await expandeRecolheTabela([idKit])

                    // Aguarda a tabela ser carregada
                    await new Promise(resolve => setTimeout(resolve, 500));

                    // Procura pelo equipamento na tabela expandida
                    const encontrados = procurarEquipamento(equipamento, idKit);

                    if (encontrados.length > 0) {
                    
                        // Excluir o equipamento encontrado
                        devolveEquipamentoBusca(encontrados[0]);
                    
                    } else {
                        snackbar.trigger(`Equipamento ${equipamento} não encontrado na tabela expandida`, 'warning');
                    }
                }

                // Limpa campo pesquisa de equipamento
                pesquisaKitEquipamento.value = ''

                // Aponta foco para o campo pesquisa equipamento
                focarNoInputPesquisa()
             
            } catch (erro) {
                erroStore.exibirErro('Erro ao buscar kits por equipamento: ' + erro.message)
                itensTabelaKits.value = []
            }

        } else {
            snackbar.trigger('Digite o código do equipamento para buscar os kits correspondentes.', 'info');
        }
    }

    // Aponta foco para o input do código de equipamento
    const focarNoInputPesquisa = () => {

        // Pequeno timeout para garantir que o DOM foi atualizado
        setTimeout(() => {
            if (inputPesquisaEquipamento.value) {
                inputPesquisaEquipamento.value.focus()
            }
        }, 100)
    }
    
    // Carrega lista de pautas cadastradas
    const carregaListaKits = async () => {

        // Limpa a tabela e expande para evitar inconsistências visuais durante o carregamento
        tabelaExpandida.value = []
                
        // Ativa o loading da tabela
        carregandoTabelaKits.value = true
        
        try {
            
            // Chama a API para carregar a lista de kits, passando o ID da empresa e o termo de pesquisa como parâmetros
            const { data } = await axios.get(
                `${API_BASE_URL}/operacao/carregaListaKits`, {
                    params: {
                        idEmpresa: loginStore.idEmpresa
                    },
                    headers: {
                        Authorization: `Bearer ${loginStore.token}`
                    }
                }
            )
            
            // Mapeia os dados retornados pela API para o formato esperado pela tabela
            itensTabelaKits.value = data.data.map(item => ({
                ...item,
                expandedData: [],
                carregandoTabelaExtendida: false
            }))
            
            // Atualiza o total de itens para a paginação
            totalItems.value = data.total || data.data.length

        } catch (erro) {

            // Exibe mensagem de erro usando a store de erros
            erroStore.exibirErro('Erro ao carregar kits: ' + erro.message)
            
            // Limpa a tabela em caso de erro
            itensTabelaKits.value = []
            
            // Define totalItems como 0 para evitar inconsistências na paginação
            totalItems.value = 0

        } finally {
            carregandoTabelaKits.value = false
        }
    }

    // Função para lidar com a expansão e recolhimento das linhas da tabela
    const expandeRecolheTabela = async (linhaSelecionada) => {
    
        // Limpa a tabela expandida para evitar que dados de outros kits apareçam durante a transição
        tabelaExpandida.value = []
        
        // Verifica se o clique foi para expandir ou recolher
        if (linhaSelecionada.length > 0) {

            // Pega APENAS o último item clicado (ignora todo o resto)
            const itemSelecionado = linhaSelecionada[linhaSelecionada.length - 1]

            // Verifica se a tabela expandida contem o idKit selecionado
            const jaEstaExpandido = tabelaExpandida.value.some(item =>
                item.idKit === itemSelecionado
            )
            
            // Se já está expandido e clicou de novo, apenas recolhe
            if (jaEstaExpandido) {
                return
            }
            
            // Aguarda próximo tick
            await nextTick()
            
            // Expande APENAS o item selecionado
            tabelaExpandida.value = [itemSelecionado]

            // Carrega os equipamentos
            await carregaEquipamentosKit(itemSelecionado)            
        }
    }

    // Função para registrar devolução de equipamento
    const iconeDevolverEquipamento = async (equipamento, kitPai) => {

        try {

            const dadosDevolucao = {
                idEmpresa: loginStore.idEmpresa,
                idColaborador: loginStore.idColaborador,
                idKit: equipamento.idKit,
                idEquipamentoKit: equipamento.idEquipamentoKit,
                idEquipamento: equipamento.idEquipamento,
                idAvaria: null,
                observacaoAvaria: null
            }

            const retornoDevolucao = await axios.post(`${API_BASE_URL}/operacao/devolveEquipamentoKit`, dadosDevolucao, {
                headers: {
                    Authorization: `Bearer ${loginStore.token}`
                }
            })
                
            // REMOVER O EQUIPAMENTO DA TABELA EXPANDIDA
            if (kitPai && kitPai.expandedData) {

                const index = kitPai.expandedData.findIndex(eq => eq.idEquipamentoKit === equipamento.idEquipamentoKit)
                if (index !== -1) {
                    kitPai.expandedData.splice(index, 1)
                }
            }

            // Se não houver mais equipamentos no kit, imprime recibo e carrega a lista de kits
            if (retornoDevolucao.data.naoDevolvidos === 0){
                
                // Imprime recibo de devolução do kit
                imprimeReciboDevolucao(equipamento.idKit)
                
                // Limpa dados do formulário de liberação
                limpaDadosAposLiberacao();
                
                // Carrega a lista de kits
                carregaListaKits()

            } else {
                snackbar.trigger(`Equipamento "${equipamento.equipamento}" Devolvido Com Sucesso`, 'success');
            }
            
            return true;

        } catch (erro) {
            
            erroStore.exibirErro('Erro Devolver Equipamento: ' + erro);
            return false;
        }
    }

    // Esta função abre modal de movimentação de equipamentos
    const iconeDevolverEquipamentoAvaria = async (equipamento, kitPai) => {
        
        // Verifique se a ref existe
        if (!modalRegistroAvariaEquipamentoref.value) {
            erroStore.exibirErro('Verifique se o componente ModalRegistroAvarias está no template')
            await nextTick()
        }
        
        // Verifica se o modal existe
        if (modalRegistroAvariaEquipamentoref.value) {

            try {

                // Abre formulário modal passando os dados
                modalRegistroAvariaEquipamentoref.value.abrirModal({
                    idKit: kitPai.idKit,
                    idEquipamentoKit: equipamento.idEquipamentoKit,
                    idEquipamento: equipamento.idEquipamento,
                    equipamento: equipamento.equipamento                    
                })

            } catch (erro) {
                erroStore.exibirErro('Erro ao abrir modal: ' + erro)
            }
        }
    }
    
    // Função para registrar movimentação de setor de equipamento
    const movimentarOutroKit = async (item) => {
        snackbar.trigger(`Movimentar equipamento: ${item.equipamento}`)
    }

    // Callback quando a movimentação é concluída
    const onRegistroAvariaConcluido = async (dadosAvaria) => {

        // Procura pelo equipamento na tabela expandida
        const encontrados = procurarEquipamento(dadosAvaria.equipamento, dadosAvaria.idKit);

        if (encontrados.length > 0) {
        
            // Excluir o equipamento encontrado
            devolveEquipamentoBusca(encontrados[0], 
                                    dadosAvaria.idAvaria, 
                                    dadosAvaria.observacaoAvaria, 
                                    dadosAvaria.enviarManutecao.value);
        
        } else {
            snackbar.trigger(`Equipamento ${dadosAvaria.equipamento} Não Encontrado`, 'warning');
        }
        
        // Fecha modal
        fecharModal()
        
        // Sucesso
        snackbar.trigger('Registro Abaria Efetuado Com Sucesso!', 'success')
    }

    // Carrega as empresas associadas ao colaborador logado
    async function carregaEmpresasColaborador() {

        try {

            const respostaApi = await axios.get(`${API_BASE_URL}/operacao/carregaEmpresaColaborador/${loginStore.idColaborador}`, {
                headers: {
                    Authorization: `Bearer ${loginStore.token}`
                }
            })

            // Busca os setores retornados pela api
            const empresasColaborador = respostaApi.data.data 

            // Atribui as empresas do colaborador à variável reativa
            empresas.value = [empresasColaborador]

        } catch (erro) {
            erroStore.exibirErro('Erro ao carregar empresas: ' + erro.message)    
        }
    }

    // Carrega equipamentos da pauta jornalística
    async function carregaEquipamentosKit(kit) {
        
        // Encontra o item na lista e ativa loading
        const kitIndex = itensTabelaKits.value.findIndex(k => k.idKit === kit)
        
        if (kitIndex === -1) return
        
        // Ativa loading para este kit
        itensTabelaKits.value[kitIndex].carregandoTabelaExtendida = true

        try {
            const response = await axios.get(
                `${API_BASE_URL}/operacao/carregaEquipamentosKit/${kit}`,
                {
                    headers: {
                        Authorization: `Bearer ${loginStore.token}`
                    }
                }
            )
            
            // Atualiza os dados expandidos do kit com os equipamentos retornados
            itensTabelaKits.value[kitIndex].expandedData = response.data.data.map(equip => ({
                idKit: equip.idKit,
                idEquipamentoKit: equip.idEquipamentoKit,
                idEquipamento: equip.idEquipamento,
                equipamento: equip.equipamento,
                descricao: equip.descricao
            }))
            
        } catch (erro) {
            erroStore.exibirErro('Erro ao carregar equipamentos do kit: ' + erro.message)
            itensTabelaKits.value[kitIndex].expandedData = []
        } finally {
            itensTabelaKits.value[kitIndex].carregandoTabelaExtendida = false
        }
    }

    // Carrega os motoristas e repórteres associados à empresa selecionada
    async function carregaDadosKit(idEmpresa) {

        try {

            // Chama a API para carregar os motoristas, repórteres e equipamentos associados à empresa selecionada
            const respostaApi = await axios.get(`${API_BASE_URL}/operacao/carregaDadosKit/${idEmpresa}`, {
                headers: {
                    Authorization: `Bearer ${loginStore.token}`
                }
            })

            // Carrega os motoristas, repórteres e equipamentos retornados pela API
            motoristas.value = respostaApi.data.motoristas
            reporteres.value = respostaApi.data.reporteres
            cinegrafistas.value = respostaApi.data.cinegrafistas
            equipamentos.value = respostaApi.data.equipamentos

        } catch (erro) {
            erroStore.exibirErro('Erro Carregar Motoristas, Repórteres e Equipamentos: ' + erro.message)    
        }        
    }

    // Esta função é responsável por validar os campos e liberar os equipamentos, 
    // podendo receber um valor (ID ou nome do equipamento) para validação
    async function validaLiberaEquipamentosComValor(valor) {

        // 'valor' pode ser ID (número) ou nome (string)
        let idEquipamento = valor
        
        // Se for string (nome), busca o ID
        if (typeof valor === 'string') {

            // Se for string (nome), busca o ID
            const equipamento = equipamentos.value.find(
                e => e.nomeEquipamento.toUpperCase() === valor.toUpperCase()
            )

            // Se encontrar o equipamento, extrai o ID
            idEquipamento = equipamento?.idEquipamento
        }
        
        // Se não encontrar o ID, exibe mensagem de erro e retorna
        if (!idEquipamento) {
            snackbar.trigger('Equipamento Não Encontrado', 'error');
            return
        }
        
        // Atualiza o v-model com o ID
        equipamentoSelecionado.value = idEquipamento
        
        // Continua com a validação normal
        const camposObrigatorios = await formLiberaEquipamentos.value?.validate()
        
        if (camposObrigatorios?.valid) {
            await insereEquipamentoKit()
        } else {
            snackbar.trigger('Preencha os Campos Obrigatórios', 'error');
        }
    }

    // Esta função é um wrapper para chamar a validação e liberação 
    // de equipamentos sem passar um valor, usando o valor atual do v-model
    async function validaLiberaEquipamentos() {
        await validaLiberaEquipamentosComValor(equipamentoSelecionado.value);
    }

    // Esta função é responsável por inserir um equipamento no kit
    async function insereEquipamentoKit() {

        try {
        
            // Chama a API para buscar dados do equipamento a ser inserido no kit
            const rows = await axios.get(`${API_BASE_URL}/operacao/buscaEquipamentoLiberacao/${equipamentoSelecionado.value}`, {
                headers: {
                    Authorization: `Bearer ${loginStore.token}`
                }
            })

            // Busca os dados do equipamento retornados pela API
            const respostaApi = rows.data.data

            if (!respostaApi) {
                erroStore.exibirErro('Equipamento Não Encontrado No Almoxarifado')
                return
            } else if (respostaApi.avaria !== 'NENHUMA') {
                erroStore.exibirErro('Equipamento Com Avaria: ' + respostaApi.avaria)
                return
            }

            // Busca o equipamento na tabela de kits para verificar se já foi adicionado
            const equipamentoExistente = equipamentosLiberados.value.find(
                equip => equip.value === respostaApi.idEquipamento
            )
            
            // Verifica se o equipamento já existe na tabela
            if (equipamentoExistente) {

                // Exibe mensagem de erro usando a store de erros
                erroStore.exibirErro('Equipamento Já Adicionado ao kit: ' + respostaApi.equipamento)
                
                // Remove a seleção do equipamento após a inserção
                equipamentoSelecionado.value = null
                return
            }
            
            // Insere o equipamento na lista de kits
            equipamentosLiberados.value.push({
                title: respostaApi.equipamento,
                value: respostaApi.idEquipamento
            })

            // Isso faz aparecer o chip imediatamente!
            equipamentosLiberadosSelecao.value.push(respostaApi.idEquipamento)

            equipamentoSelecionado.value = null

            // Dá foco ao campo
            focoEquipamentos()

        } catch (erro) {
            erroStore.exibirErro('Erro Inserir kit: ' + erro.message)
        }
    }

    // Rotina para liberar o kit de equipamentos
    async function liberarKit() {

        // Verifica se há equipamentos no kit antes de liberar
        if (equipamentosLiberadosSelecao.value.length === 0) {
            erroStore.exibirErro('Para Liberar Kit, Adicione Pelo Menos Um Equipamento')
            return
        }

        // Cria um objeto com os dados da pauta a ser salva
        const dadosKit = {
            idEmpresa: empresaSelecionada.value,
            idMotorista: motoristaSelecionado.value,
            idReporter: reporterSelecionado.value,
            idCinegrafista: cinegrafistaSelecionado.value,
            idCriouPauta: loginStore.idColaborador,
            descricaoPauta: descricaoPauta.value,
            equipamentos: equipamentosLiberadosSelecao.value
        }

        try{
            
            // Chama a API para salvar os dados da pauta e liberar os equipamentos
            const retornoApi = await axios.post(`${API_BASE_URL}/operacao/criaKitEquipamentos`, dadosKit, {
                headers: {
                    Authorization: `Bearer ${loginStore.token}`
                }
            })

            // Salva o idKit gerado
            const idKit = retornoApi.data.idKit

            snackbar.trigger('Equipamentos Liberados com Sucesso!')

            // Limpa os dados do formulário e tabela após liberar o kit
            limpaDadosAposLiberacao()
            
            // Recarrega a lista de kits para mostrar o novo kit liberado
            carregaListaKits()

            // Imprime recibo de liberação de kit
            imprimeReciboLiberacao(idKit)
            
        } catch (erro) {
            erroStore.exibirErro('Erro ao liberar equipamento: ' + erro.message)
        }
    }

    // Esta função faz a devolução de um kit
    async function devolveEquipamentoBusca(itemEncontrado, idAvaria = null, observacaoAvaria = null, enviarManutecao = null) {

        if (!itemEncontrado || !itemEncontrado.kit || !itemEncontrado.kit.expandedData) {
            return false;
        }
        
        try {

            const dadosDevolucao = {
                idEmpresa: loginStore.idEmpresa,
                idColaborador: loginStore.idColaborador,
                idKit: itemEncontrado.item.idKit,
                idEquipamentoKit: itemEncontrado.item.idEquipamentoKit,
                idEquipamento: itemEncontrado.item.idEquipamento,
                idAvaria: idAvaria,
                observacaoAvaria: observacaoAvaria,
                enviarManutecao: enviarManutecao
            }

            // Chama api para devolução do equipamento
            const retornoDevolucao = await axios.post(`${API_BASE_URL}/operacao/devolveEquipamentoKit`, dadosDevolucao, {
                headers: {
                    Authorization: `Bearer ${loginStore.token}`
                }
            })
                        
            // Remove o equipamento do array
            itemEncontrado.kit.expandedData.splice(itemEncontrado.index, 1);
            
            // Se não houver mais equipamentos no kit, imprime recibo e carrega a lista de kits
            if (retornoDevolucao.data.naoDevolvidos === 0){
                
                // Se o idAvaria for diferente de null, imprime recibo de equipamento com defeito
                if (idAvaria){
                    imprimeReciboDevolucaoDefeito(itemEncontrado.item.idKit, observacaoAvaria)
                } else{
                    imprimeReciboDevolucao(itemEncontrado.item.idKit)
                }
                
                // Limpa dados do formulário de liberação
                limpaDadosAposLiberacao();
                
                // Carrega a lista de kits
                carregaListaKits()

                snackbar.trigger(`Equipamento "${itemEncontrado.valor}" Devolvido Com Sucesso.`, 'success');

            } else if (idAvaria){
                imprimeReciboDevolucaoDefeito(itemEncontrado.item.idKit)
            }                
            
            return true;

        } catch (erro) {
            
            erroStore.exibirErro('Erro Devolver Equipamento: ' + erro);
            return false;
        }
    }
    
    // Esta rotina imprime o recibo de liberação dos equipamentos do kit
    async function imprimeReciboLiberacao(idKit) {
        
        try {
            
            // Faz a chamada à API
            const response = await axios.get(
                `${API_BASE_URL}/operacao/montaReciboKit/${idKit}`,
                {
                    headers: {
                        Authorization: `Bearer ${loginStore.token}`
                    }
                }
            )
            
            // Verifica se a resposta é válida
            if (!response?.data) {
                throw new Error('Resposta inválida da API')
            }
            
            // Extrai os dados (ajuste conforme sua estrutura)
            const dadosRecibo = response.data.data
            const equipamentos = response.data.equipamentos || []
            
            // Valida se tem os dados mínimos
            if (!dadosRecibo) {
                throw new Error('Dados do recibo não encontrados')
            }
            
            // Formata a data
            const dataFormatada = dadosRecibo.dataLiberacao 
                ? new Date(dadosRecibo.dataLiberacao).toLocaleDateString('pt-BR')
                : '___/___/_____'
            
            // Monta o texto do recibo
            const textoRecibo = `
                <div style="text-align: center;">
                    <h2>${dadosRecibo.nomeEmpresa || 'Empresa'}</h2>
                    <h3>RECIBO LIBERAÇÃO KIT ${dadosRecibo.idKit || ''}</h3>
                </div>
                
                <div style="margin-top: 20px; width: 100%;">
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">LIBEROU...............:</div>
                        <div>${dadosRecibo.liberouPauta || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">MOTORISTA..........:</div>
                        <div>${dadosRecibo.nomeMotorista || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">CINEGRAFISTA.....:</div>
                        <div>${dadosRecibo.nomeCinegrafista || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">REPÓRTER............:</div>
                        <div>${dadosRecibo.nomeReporter || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">LIBERADO EM.......:</div>
                        <div>${dataFormatada}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">PAUTA....................:</div>
                        <div>${dadosRecibo.descricaoPauta || 'N/I'}</div>
                    </div>
                </div>
                
                <div style="margin-top: 20px;">
                    <p style="font-weight: bold; margin-bottom: 5px;">EQUIPAMENTOS:</p>
                    <ul style="margin-top: 0;">
                        ${equipamentos.map(e => 
                            `<li>${e.equipamento || ''} - ${e.descricao || ''}</li>`
                        ).join('')}
                    </ul>
                </div>
                
                <div style="margin-top: 40px; text-align: right;">
                    <p>_________________________________</p>
                    <p>Assinatura</p>
                </div>
            `
            
            // Chama o serviço de impressão e VERIFICA O RETORNO
            const resultado = await impressaoService.gerarReciboPautaJornalistica(textoRecibo)
            
            // Agora verifica a propriedade sucesso
            if (resultado?.sucesso) {
                snackbar.trigger('Recibo enviado para impressão!', 'success');
            } else {
                snackbar.trigger('Erro ao enviar recibo para impressão: ' + resultado?.mensagem, 'error');
            }
    
        } catch (erro) {
            erroStore.exibirErro('Erro ao Gerar Recibo Liberação: ' + erro.message)
        }
    }
    
    // Esta rotina imprime o recibo de devolucao dos equipamentos do kit
    async function imprimeReciboDevolucao(idKit) {
        
        try {
            
            // Faz a chamada à API
            const response = await axios.get(
                `${API_BASE_URL}/operacao/montaReciboKit/${idKit}`,
                {
                    headers: {
                        Authorization: `Bearer ${loginStore.token}`
                    }
                }
            )
            
            // Extrai os dados (ajuste conforme sua estrutura)
            const dadosRecibo = response.data.data
            const equipamentos = response.data.equipamentos || []
            
            // Formata a data
            const dataFormatada = dadosRecibo.dataLiberacao 
                ? new Date(dadosRecibo.dataLiberacao).toLocaleDateString('pt-BR')
                : '___/___/_____'
            
            // Monta o texto do recibo
            const textoRecibo = `
                <div style="text-align: center;">
                    <h2>${dadosRecibo.nomeEmpresa || 'Empresa'}</h2>
                    <h3>RECIBO DEVOLUÇÃO KIT ${dadosRecibo.idKit || ''}</h3>
                </div>
                
                <div style="margin-top: 20px; width: 100%;">
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">LIBEROU...............:</div>
                        <div>${dadosRecibo.liberouPauta || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">MOTORISTA..........:</div>
                        <div>${dadosRecibo.nomeMotorista || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">CINEGRAFISTA.....:</div>
                        <div>${dadosRecibo.nomeCinegrafista || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">REPÓRTER............:</div>
                        <div>${dadosRecibo.nomeReporter || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">LIBERADO EM.......:</div>
                        <div>${dataFormatada}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">PAUTA....................:</div>
                        <div>${dadosRecibo.descricaoPauta || 'N/I'}</div>
                    </div>
                </div>
                
                <div style="margin-top: 20px;">
                    <p style="font-weight: bold; margin-bottom: 5px;">EQUIPAMENTOS:</p>
                    <ul style="margin-top: 0;">
                        ${equipamentos.map(e => 
                            `<li>${e.equipamento || ''} - ${e.descricao || ''}</li>`
                        ).join('')}
                    </ul>
                </div>
                
                <div style="text-align: center;">
                    <h3>Eu, o abaixo assinado, confirmo a DEVOLUÇÃO</h3>
                </div>                
                <div style="text-align: center;">
                    <h3>dos equipamentos listados acima em perfeitas</h3>
                </div>
                <div style="text-align: center;">
                    <h3>condições de funcionamento.</h3>
                </div>
                <div style="margin-top: 40px; text-align: right;">
                    <p>_________________________________</p>
                    <p>Assinatura</p>
                </div>
            `
            
            // Chama o serviço de impressão e VERIFICA O RETORNO
            const resultado = await impressaoService.gerarReciboPautaJornalistica(textoRecibo)
            
            // Agora verifica a propriedade sucesso
            if (resultado?.sucesso) {
                snackbar.trigger('Recibo enviado para impressão!', 'success');
            } else {
                snackbar.trigger('Erro ao enviar recibo para impressão: ' + resultado?.mensagem, 'error');
            }
    
        } catch (erro) {
            erroStore.exibirErro('Erro ao Gerar Recibo Devolução: ' + erro.message)
        }
    }

    // Esta rotina imprime o recibo de devolucao dos equipamentos do kit
    async function imprimeReciboDevolucaoDefeito(idKit, observacaoAvaria) {
        
        try {
            
            // Faz a chamada à API
            const response = await axios.get(
                `${API_BASE_URL}/operacao/montaReciboKit/${idKit}`,
                {
                    headers: {
                        Authorization: `Bearer ${loginStore.token}`
                    }
                }
            )
            
            // Extrai os dados (ajuste conforme sua estrutura)
            const dadosRecibo = response.data.data
            const equipamentos = response.data.equipamentos || []
            
            // Formata a data
            const dataFormatada = dadosRecibo.dataLiberacao 
                ? new Date(dadosRecibo.dataLiberacao).toLocaleDateString('pt-BR')
                : '___/___/_____'
            
            // Monta o texto do recibo
            const textoRecibo = `
                <div style="text-align: center;">
                    <h2>${dadosRecibo.nomeEmpresa || 'Empresa'}</h2>
                    <h3>RECIBO DEVOLUÇÃO KIT ${dadosRecibo.idKit || ''}</h3>
                </div>
                
                <div style="margin-top: 20px; width: 100%;">
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">LIBEROU...............:</div>
                        <div>${dadosRecibo.liberouPauta || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">MOTORISTA..........:</div>
                        <div>${dadosRecibo.nomeMotorista || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">CINEGRAFISTA.....:</div>
                        <div>${dadosRecibo.nomeCinegrafista || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">REPÓRTER............:</div>
                        <div>${dadosRecibo.nomeReporter || 'N/I'}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">LIBERADO EM.......:</div>
                        <div>${dataFormatada}</div>
                    </div>
                    <div style="display: flex; margin-bottom: 5px;">
                        <div style="width: 150px; font-weight: bold;">PAUTA....................:</div>
                        <div>${dadosRecibo.descricaoPauta || 'N/I'}</div>
                    </div>
                </div>
                
                <div style="margin-top: 20px;">
                    <p style="font-weight: bold; margin-bottom: 5px;">EQUIPAMENTOS:</p>
                    <ul style="margin-top: 0;">
                        ${equipamentos.map(e => 
                            `<li>${e.equipamento || ''} - ${e.descricao || ''}</li>`
                        ).join('')}
                    </ul>
                </div>
                
                <div style="text-align: center;">
                    <h3>Eu, o abaixo assinado, confirmo a DEVOLUÇÃO</h3>
                </div>                
                <div style="text-align: center;">
                    <h3>do equipamento listado acima com <b>AVARIA</b></h3>
                </div>
                <div style="text-align: center;">
                    <h3>descrita abaixo:</h3>
                </div>
                <div style="text-align: center;">
                    <h3><b>${observacaoAvaria}</b></h3>
                </div>
                <div style="margin-top: 40px; text-align: right;">
                    <p>_________________________________</p>
                    <p>Assinatura</p>
                </div>
            `
            
            // Chama o serviço de impressão e VERIFICA O RETORNO
            const resultado = await impressaoService.gerarReciboPautaJornalistica(textoRecibo)
            
            // Agora verifica a propriedade sucesso
            if (resultado?.sucesso) {
                snackbar.trigger('Recibo enviado para impressão!', 'success');
            } else {
                snackbar.trigger('Erro ao enviar recibo para impressão: ' + resultado?.mensagem, 'error');
            }
    
        } catch (erro) {
            erroStore.exibirErro('Erro ao Gerar Recibo Devolução: ' + erro.message)
        }
    }

    // Esta função procura um equipamento na tabela expandida
    function procurarEquipamento(equipamento, idKit) {

        if (!equipamento) return [];
        
        const encontrados = [];
        const chaveTerceiraColuna = 'equipamento';
        
        // Encontra o kit específico
        const kit = itensTabelaKits.value.find(k => k.idKit === idKit);
        
        if (!kit) {
            return [];
        }
        
        if (kit.expandedData && Array.isArray(kit.expandedData)) {

            kit.expandedData.forEach((item, idx) => {

                const valorColuna = item[chaveTerceiraColuna];
                
                if (valorColuna && valorColuna.toString().toUpperCase() === equipamento.toString().toUpperCase()) {

                    encontrados.push({
                        kit: kit,
                        item: item,
                        index: idx,
                        valor: valorColuna
                    });
                }
            });
        }
        
        return encontrados;
    }

    // Esta função é chamada quando o usuário pressiona Enter no campo de equipamento para processar a entrada digitada
    function processarEnter(event) {

        // Obtém o valor digitado, converte para maiúsculas e remove espaços extras
        const nomeDigitado = event.target.value?.toUpperCase().trim() || ''
        
        // Verifica se o campo está vazio
        if (!nomeDigitado) {
            snackbar.trigger('Digite Nome Equipamento', 'error');
            return
        }
        
        // Variável para armazenar o equipamento encontrado
        let equipamentoEncontrado = null
        
        // Busca o equipamento na lista de equipamentos disponíveis usando o nome digitado
        equipamentoEncontrado = equipamentos.value.find(
            e => e.nomeEquipamento.toUpperCase() === nomeDigitado
        )
        
        // Verifica se encontrou o equipamento
        if (equipamentoEncontrado) {
            
            // Atualiza o v-model com o ID do equipamento encontrado
            equipamentoSelecionado.value = equipamentoEncontrado.idEquipamento
            
            // Chama a função de validação e liberação de equipamentos passando o ID do equipamento encontrado
            validaLiberaEquipamentosComValor(equipamentoEncontrado.idEquipamento)
            
        } else {
            
            // Exibe mensagem de erro usando o snackbar
            snackbar.trigger(`Equipamento "${nomeDigitado}" Não Cadastrado`, 'error');
            
            // Limpa o campo
            equipamentoSelecionado.value = null
            event.target.value = '' // Limpa o input
            event.target.focus()    // Mantém foco
        }
    }

    // Função dedicada para dar foco ao campo de equipamento após inserir um item no kit
    function focoEquipamentos() {

        // Força recriação do componente
        mostrarAutocomplete.value = false
        
        // Dá um pequeno delay para garantir que o componente seja destruído antes de recriar
        setTimeout(() => {

            // Recria o componente para resetar seu estado
            mostrarAutocomplete.value = true
            
            // Dá outro pequeno delay para garantir que o componente seja recriado antes de tentar focar o campo
            setTimeout(() => {

                // Dá foco ao campo de equipamento usando a referência
                if (focoEquipamento.value) {

                    // Usa querySelector para encontrar o input dentro do componente v-autocomplete e dar foco
                    const input = focoEquipamento.value.$el?.querySelector('input')
                    if (input) {
                        input.focus()
                        input.select()
                    }
                }
            }, 50)
        }, 50)
    }
    
    // Esta função remove equipamentos do kit na tabela
    function removeEquipamentosKit(item) {
        
        try {

            // Remove equipamento da seleção
            const indexSelecao = equipamentosLiberadosSelecao.value.indexOf(item.value)
            if (indexSelecao > -1) {
                equipamentosLiberadosSelecao.value.splice(indexSelecao, 1)
            }
            
            // Remove equipamento da lista de itens disponíveis
            const indexItem = equipamentosLiberados.value.findIndex(e => e.value === item.value)
            if (indexItem > -1) {
                equipamentosLiberados.value.splice(indexItem, 1)
            }            
            
        } catch (erro) {
            erroStore.exibirErro('Erro ao remover equipamento: ' + erro.message);
        }
    }
    
    // Quando a seleção mudar
    function aoAtualizarSelecao(novaSelecao) {
        
        // Encontra itens que foram removidos da seleção comparando 
        // a nova seleção com a lista completa de equipamentos liberados
        const itensRemovidos = equipamentosLiberados.value.filter(
            equipamento => !novaSelecao.includes(equipamento.value)
        )
        
        // Remove cada item removido da lista completa
        itensRemovidos.forEach(item => {

            // Procura index do item a ser removido na lista completa
            const index = equipamentosLiberados.value.findIndex(
                equipamento => equipamento.value === item.value
            )

            // Remove o item da lista completa
            if (index > -1) {
                equipamentosLiberados.value.splice(index, 1)
            }
        })
    }

    // Função para limpar os dados do formulário e tabela após liberar o kit
    function limpaDadosAposLiberacao() {
        
        // Limpa os campos do formulário
        //empresaSelecionada.value = null
        motoristaSelecionado.value = null
        reporterSelecionado.value = null
        cinegrafistaSelecionado.value = null
        descricaoPauta.value = ''
        
        // Limpa elementos v-select para forçar atualização da interface
        motoristas.value = []
        reporteres.value = []   
        cinegrafistas.value = []
        equipamentosLiberados.value = []
        equipamentosLiberadosSelecao.value = []
        
        // Recarrega os motoristas, repórteres e cinegrafistas para atualizar a disponibilidade dos mesmos
        carregaDadosKit(empresaSelecionada.value)
    }

    // Função que lê o tamanho da barra no localStorage e aplica na 
    function ajustaBarraPretaTopo(){
        
        if (localStorage.getItem('tamanhoBarraLaterar') == 'true'){
            modoBarraLateral.value = true
        } else{
            modoBarraLateral.value = false
        }
    }

    // Rotina chamada quando o componente é montado
    onMounted(() => {

        // Listener para mudanças do drawer
        const manipuladorMudancaTamanho = (data) => {

            // Salva valor emitido pelo botão de minimizar/maximizar a barra lateral
            localStorage.setItem('tamanhoBarraLaterar', data)            
            
            // Ajusta barra preta do topo do formulário
            ajustaBarraPretaTopo()
        }
    
        // Adiciona listener para mudanças do drawer
        emitter.on('mudancaBarraLateral', manipuladorMudancaTamanho)

        // Ajusta a barra preta do topo do fomulário com o valor do localStorage
        ajustaBarraPretaTopo()

        // Carrega as empresas do colaborador
        carregaEmpresasColaborador()      
    })

    // Rotina chamada antes de desmontar o componente
    onBeforeUnmount(() => {

        // Limpar listener
        emitter.off('mudancaBarraLateral')
    })

</script>

<style scoped>
    .expanded-data-table {
        font-size: 0.75rem; /* 12px */
    }

    .expanded-data-table .v-data-table-header th {
        font-size: 0.7rem !important;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .expanded-data-table td {
        padding: 2px 8px !important;
    }

    /* Ajuste para telas pequenas */
    @media (max-width: 600px) {
        .expanded-data-table {
            font-size: 0.7rem;
        }
    }
</style>
